import script from "./PlatformOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./PlatformOrder.vue?vue&type=script&setup=true&lang=js"

import "./PlatformOrder.vue?vue&type=style&index=0&id=0289bef0&lang=scss&scoped=true"

import exportComponent from "/home/viction/eshopcommand/source/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0289bef0"]])

export default __exports__